import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UpgradePromptProps {
  message: string;
  onClose: () => void;
  show: boolean;
}

const UpgradePrompt: React.FC<UpgradePromptProps> = ({ message, onClose, show }) => {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '10px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '20px' }}>Upgrade Required</h2>
        <p style={{ marginBottom: '30px', color: '#666', lineHeight: '1.6' }}>{message}</p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            className="btn btn-secondary"
          >
            Maybe Later
          </button>
          <button
            onClick={() => {
              navigate('/pricing');
              onClose();
            }}
            className="btn btn-primary"
          >
            View Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;
